import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ds-img/filter.png'
import _imports_1 from '@/assets/ds-img/go-cus.png'
import _imports_2 from '@/assets/ds-img/go-cus-grey.png'


const _withScopeId = n => (_pushScopeId("data-v-eb06606e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desk-container" }
const _hoisted_2 = { class: "breadcrumb-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "ctn-left" }
const _hoisted_5 = { class: "ctl-search" }
const _hoisted_6 = { class: "filter" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px","height":"20px"}
}, null, -1))
const _hoisted_8 = { class: "ctl-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "ctl-item-left" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "ctl-item-right" }
const _hoisted_13 = { class: "ctl-item-title" }
const _hoisted_14 = { class: "ctl-item-opt" }
const _hoisted_15 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px","height":"20px"}
}
const _hoisted_16 = {
  key: 1,
  src: _imports_2,
  style: {"width":"20px","height":"20px"}
}
const _hoisted_17 = { class: "ctn-right" }
const _hoisted_18 = { class: "ctn-right-tabs-content" }
const _hoisted_19 = { class: "simple-info" }
const _hoisted_20 = { class: "simple-info-avatar" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "simple-info-data" }
const _hoisted_23 = { class: "simple-info-name" }
const _hoisted_24 = { style: {"color":"#999999"} }
const _hoisted_25 = { class: "simple-info-tags" }
const _hoisted_26 = { class: "simple-info-tag-item" }
const _hoisted_27 = { class: "extra-info" }
const _hoisted_28 = { class: "simple-info-tag-item" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "scroll-view" }
const _hoisted_31 = { class: "live-data data-item" }
const _hoisted_32 = { class: "fubo-data data-item" }
const _hoisted_33 = { class: "voice-record data-item" }
const _hoisted_34 = { class: "cus-journey data-item" }

import { useStore } from "@/store";
import NavBar from "@/components/NavBar.vue";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { ElLoading, ElMessage } from "element-plus";
import NumberCard from "@/components/NumberCard.vue";
import TimeLineCard from "@/components/TimeLineCard.vue";
import CommonPlanCard from "@/components/CommonPlanCard.vue";
import CommonPlanMethodCard from "@/components/CommonPlanMethodCard.vue"
import { queryCustomerDetailsInfo, queryCustomerList } from "@/service/desk-top/custom-detail";
import { ILoadingInstance } from "element-plus/lib/el-loading/src/loading.type";
import FilterCard from "@/components/FilterCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-detail',
  setup(__props) {

const store = useStore()
const userInfo = store.state.login.userInfo

const searchValue = ref('')
const handleClear = () => {
  searchValue.value = ''
}
const handleSearch = () => {
  pageNo.value = 0
  accList.value = []
  loadCustomerList()
}

const accList: any = ref([])

const pageNo = ref(0)
const pageSize = ref(15)
const total = ref(0)
const filter:any = ref({
  type: 0,
  subType: 0
})

watch(filter, (newValue) => {
  pageNo.value = 0
  accList.value = []
  loadCustomerList()
})

const scrollContainer: any = ref(null);

const handleScroll = () => {
  if (!scrollContainer.value) return;
  const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
  if (scrollTop + clientHeight >= scrollHeight - 1) { // 接近底部
    if (accList.value.length < total.value){
      loadCustomerList();
    }
  }
};
const cusLoadding = ref(false)
const loadCustomerList = () => {
  if(!cusLoadding.value){
    cusLoadding.value = true
    pageNo.value++
    const queryInfo = {
      keyValue: encodeURIComponent(searchValue.value),
      pageNo: pageNo.value,
      pageSize: pageSize.value,
      ...filter.value
    }
    queryCustomerList(queryInfo).then(res => {
      if (res) {
        total.value = res.total
        if(pageNo.value > 1) {
          accList.value = [...accList.value, ...res.list]
        } else {
          accList.value = res.list
          cacheData.value = []
        }
      }
      cusLoadding.value = false
    })
  }
}
const customUniqueId = ref('')
const currentCustomerId = ref('')
const currentCustomer: any = ref({})
const cacheData: any = ref([])
let detailLoadingInstance: ILoadingInstance = {} as ILoadingInstance
const array: any = ref([])
const loadCustomerData = (cus: any) => {
  array.value.forEach((instance: ILoadingInstance) => {
    if(instance){
      instance.close()
    }
  })
  detailLoadingInstance = ElLoading.service({
    lock: true,
    text: '正在加载中...',
    target: '.ctn-right-tabs-content',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  array.value.push(detailLoadingInstance)
  customUniqueId.value = cus.id
  currentCustomerId.value = cus.userId
  currentCustomer.value = cus
  customInfoActive.value = 'baseInfo'
  const queryInfo = {
    userId: cus.userId,
    corpId: cus.corpId,
    unionId: cus.unionId,
    wxAccount: cus.wxAccount
  }
  if(cacheData.value.indexOf(cus.id) == -1) {
    queryCustomerDetailsInfo(queryInfo).then((res) => {
      cacheData.value.push(cus.id)
      currentCustomer.value.tags = [
        {
          label: '所属',
          value: res.groupName
        },
        {
          label: '业务员',
          value: res.empName
        },
        {
          label: '跟踪天数',
          value: currentCustomer.value.followData?currentCustomer.value.followData.length:0
        },
        {
          label: '来源渠道',
          value: res.channel
        },
        {
          label: '加入时间',
          value: res.createdAt
        }
      ]
      currentCustomer.value.extraInfo = [
        {
          label: '客户ID',
          value: res.userId,
          canCopy: true
        },
        {
          label: 'UnionID',
          value: res.unionId,
          canCopy: true
        },
        {
          label: '账号ID',
          value: res.wxAccount,
          canCopy: true
        }
      ]
      currentCustomer.value.liveData = [
        {
          icon: require('@/assets/ds-img/live_keep.png'),
          label: '持续观看天数',
          num: res.liveContinueWatchDays,
          unit: '天'
        },
        {
          icon: require('@/assets/ds-img/comm_total.png'),
          label: '观看总时长',
          num: res.liveWatchDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_top.png'),
          label: '观看最大时间',
          num: res.liveWatchMaxDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_bottom.png'),
          label: '观看最小时间',
          num: res.liveWatchMinDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_avg.png'),
          label: '观看平均时间',
          num: res.liveWatchAvgDuration,
          format: getMiniute
        },
      ]
      currentCustomer.value.fuboData = [
        {
          icon: require('@/assets/ds-img/fubo_keep.png'),
          label: '观看课程数量',
          num: res.fbWatchCourseNum,
          unit: '个'
        },
        {
          icon: require('@/assets/ds-img/comm_total.png'),
          label: '观看总时长',
          num: res.fbWatchDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_top.png'),
          label: '观看最大时间',
          num: res.fbWatchMaxDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_bottom.png'),
          label: '观看最小时间',
          num: res.fbWatchMinDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_avg.png'),
          label: '观看平均时间',
          num: res.fbWatchAvgDuration,
          format: getMiniute
        },
      ]
      currentCustomer.value.voiceRecord = [
        {
          icon: require('@/assets/ds-img/voice_keep.png'),
          label: '通话总时长',
          num: res.callTotalDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_top.png'),
          label: '通话最大时间',
          num: res.callMaxDuration,
          format: getMiniute
        },
        {
          icon: require('@/assets/ds-img/comm_bottom.png'),
          label: '通话最小时间',
          num: res.callMinDuration,
          format: getMiniute
        }
      ]
      detailLoadingInstance.close()
    })
  }  else {
    detailLoadingInstance.close()
  }
}

const getMiniute = (seconds: number) => {
  // seconds单位是秒，如果大于1小时，显示x h x min，如果小于1小时，显示x min， 如果小于1min 显示x s
  if(seconds >= 3600) {
    return {
      h: Math.floor(seconds / 3600),
      m: Math.floor((seconds % 3600) / 60)
    }
  } else if(seconds >= 60) {
    return {
      m: Math.floor(seconds / 60),
    }
  } else if(seconds >= 0) {
    return {
      s: Math.floor(seconds)
    }
  }
}

const handleCopy =  (text: string) => {
  navigator.clipboard.writeText(text)
  ElMessage.success('复制成功')
}

const customInfoActive = ref('')


onMounted(() => {
  loadCustomerList()
  scrollContainer.value?.addEventListener('scroll', handleScroll);
})

onBeforeUnmount(() => {
  scrollContainer.value?.removeEventListener('scroll', handleScroll)
})


return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_breadcrumb, { separator: "＞" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
            default: _withCtx(() => [
              _createTextVNode("桌面")
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, { class: "current" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(userInfo).nickName) + "的客户列表 ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            placeholder: "请输入客户信息搜索",
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            clearable: "",
            onClear: handleClear,
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: "el-icon-search",
                class: "search-btn",
                onClick: handleSearch
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_popover, {
              placement: "right-start",
              width: 504,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createVNode(FilterCard, {
                  title: "条件筛选",
                  modelValue: filter.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "ctl-list-item infinite-list",
            ref_key: "scrollContainer",
            ref: scrollContainer,
            "infinite-scroll-distance": "5"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accList.value, (cus, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(customUniqueId.value == cus.id ? 'ctl-item cus-active' : 'ctl-item'),
                onClick: ($event: any) => (loadCustomerData(cus))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: cus.avatar,
                    style: {"width":"40px","height":"40px"}
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(cus.nickName), 1),
                  _createElementVNode("div", _hoisted_14, [
                    (cus.id == customUniqueId.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                      : (_openBlock(), _createElementBlock("img", _hoisted_16))
                  ])
                ])
              ], 10, _hoisted_9))
            }), 256)),
            (cusLoadding.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "default",
                  loading: cusLoadding.value,
                  style: {"width":"100%"},
                  plain: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("加载中")
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            (!cusLoadding.value && accList.value.length == total.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "default",
                  style: {"width":"100%"},
                  plain: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("没有更多了")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])), [
            [_directive_infinite_scroll, loadCustomerList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_tabs, {
          modelValue: customInfoActive.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customInfoActive).value = $event)),
          class: "ctn-right-tabs",
          type: "border-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "客户基本信息",
              name: "baseInfo"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("img", {
                        src: currentCustomer.value.avatar,
                        style: {"width":"80px","height":"80px"}
                      }, null, 8, _hoisted_21)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString(currentCustomer.value.nickName), 1),
                        _createElementVNode("span", _hoisted_24, "（" + _toDisplayString(currentCustomer.value.remark) + "）", 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCustomer.value.tags, (tag, index) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: index,
                            color: '#105BFC14'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(tag.label) + "：" + _toDisplayString(tag.value), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCustomer.value.extraInfo, (extra, index) => {
                      return (_openBlock(), _createBlock(_component_el_tag, {
                        key: index,
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(extra.label) + "：" + _toDisplayString(extra.value), 1),
                          (extra.canCopy)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "el-icon-copy-document",
                                style: {"cursor":"pointer","margin-left":"10px"},
                                onClick: ($event: any) => (handleCopy(extra.value))
                              }, null, 8, _hoisted_29))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _createVNode(_component_el_divider, { "content-position": "left" }, {
                    default: _withCtx(() => [
                      _createTextVNode("统计数据")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(NumberCard, {
                        title: '观看直播数据',
                        cards: currentCustomer.value.liveData
                      }, null, 8, ["cards"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(NumberCard, {
                        title: '观看复播数据',
                        cards: currentCustomer.value.fuboData
                      }, null, 8, ["cards"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(NumberCard, {
                        title: '客户通话数据',
                        cards: currentCustomer.value.voiceRecord
                      }, null, 8, ["cards"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      (currentCustomer.value.unionId)
                        ? (_openBlock(), _createBlock(TimeLineCard, {
                            key: 0,
                            title: '客户轨迹',
                            modelValue: currentCustomer.value.journeyData,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentCustomer.value.journeyData) = $event)),
                            "union-id": currentCustomer.value.unionId
                          }, null, 8, ["modelValue", "union-id"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})